// extracted by mini-css-extract-plugin
module.exports = {"copyright":"copyright_copyright__JwiFg"};